import React,{useEffect} from 'react'
import {TextField,Grid, Box,Button} from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { PartnerWithUsFourSchema } from '../../Utils/Validations'

const PartnerWithUsFour = ({ handleBack, handleComplete, partnerWithUsData, setPartnerWithUsData }) => {
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(PartnerWithUsFourSchema)
  })
  useEffect(() => {
    setValue("city", partnerWithUsData.city || "")
    setValue("state", partnerWithUsData.state || "")
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setPartnerWithUsData((prev) => ({ ...prev, city: data.city, state: data.state }))
    handleComplete()
  }
  return (
    <div>
        
        <Grid container  style={{justifyContent:"center",marginTop:20}} >
            <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0}}} >
            <Controller
            control={control}
            name="city"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                 <label>City</label>
                <TextField fullWidth placeholder='City'  {...field} error={errors.city} helperText={errors?.city?.message} />
              </>
            )}
          />
              
     
        
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingLeft:{sm:1,xs:0},marginTop:{sm:0,xs:2}}}>
        <Controller
            control={control}
            name="state"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                 <label>State</label>
                <TextField fullWidth placeholder="State" {...field} error={errors.state} helperText={errors?.state?.message} />

              </>
            )}
          />
       
        
        </Grid>
        </Grid>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default PartnerWithUsFour